import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchSheetData, sheetsConfig } from '../utils/sheetsApi';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const results = {};
        for (const [key, sheetName] of Object.entries(sheetsConfig.sheets)) {
          const sheetData = await fetchSheetData(sheetName);
          results[key] = sheetData;
        }
        setData(results);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  return (
    <DataContext.Provider value={{ data, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
